import { useState } from 'react';

const TemplateDisplay = ({ items, cargarTemplate, editarTemplate }) => {

  if (items != null && items != "") {
    return (
      <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
        {items.map((item, index) => {
          const [mostrarOpciones, setMostrarOpciones] = useState(false);

          return (
            <table key={item.id} style={{ width: '100%' }}> 
              <thead></thead>
              <tbody>
                <tr>
                  <td>
                    <div style={{ position: 'relative', display: 'inline-block' }}>
                      <button
                        className="cewy-qrcode-button2"
                        type="button"
                        onClick={() => setMostrarOpciones(!mostrarOpciones)}
                      >
                        {item.id}-{item.nombre}
                      </button>

                      {mostrarOpciones && (
                        <div
                          style={{
                            position: 'absolute',
                            top: '100%',
                            left: 0,
                            backgroundColor: '#fff',
                            border: '1px solid #ddd',
                            boxShadow: '0 2px 5px rgba(0, 0, 0, 0.2)',
                            zIndex: 10,
                          }}
                        >
                          <button className="cewy-qrcode-button2" onClick={() => editarTemplate(item)}>Editar</button>
                          <button className="cewy-qrcode-button2" onClick={() => cargarTemplate(item)}>Aplicar</button>
                        </div>
                      )}
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          );
        })}
      </div>
    );
  }
}

export default TemplateDisplay;
